import React from "react";

import * as R from "ramda";

import { css } from "glamor";

const styles = {
    category: css({
        backgroundColor: "#d0d0d0",
        borderRadius: "3px",
        color: "#fff",
        display: "inline-block",
        fontSize: ".8em",
        marginRight: ".2em",
        minWidth: "25px",
        padding: ".1em",
        textAlign: "center",
    }),
    categories: {
        AM: css({
            backgroundColor: "#ffe050",
        }),
        ENF: css({
            backgroundColor: "#f78c8c",
        }),
        PEP: css({
            backgroundColor: "#ffaf48",
        }),
        SAN: css({
            backgroundColor: "#f76a6a",
        }),
    },
};

const mappings = {
    "Adverse Media": "AM",
    "Associated Entity": "AE",
    "Sanction List": "SAN",
    Enforcement: "ENF",
    PEP: "PEP",
    Registrations: "REG",
    SOE: "SOE",
};

const Category = ({ children }) => {
    if (!children) {
        return null;
    }

    const categoryShort = mappings[children];

    return (
        <div
            {...styles.category}
            {...styles.categories[categoryShort]}
            title={children}
        >
            {categoryShort}
        </div>
    );
};

const Categories = ({ children }) => {
    if (!children) {
        return null;
    }

    const getCategories = R.pipe(
        R.split(";"),
        R.sort((a, b) => {
            return a - b;
        })
    );

    return (
        <div>
            {getCategories(children).map(category => (
                <Category key={category}>{category}</Category>
            ))}
        </div>
    );
};

export default Categories;
